var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "observe-module",
    staticStyle: { display: "none" },
    domProps: { innerHTML: _vm._s("<!--tiny-->") },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }